import { encodeToSHA256HashString } from '../helpers';

type SignupEventData = {
  event: 'self_sign_up_completed';
  trigger: 'GAevent';
  event_id: 5;
  eventCategory: 'self_sign_up_flow';
  hashedEmail?: string;
};

export const getGTMSignupEvent = async ({ email }: { email: string }) => {
  const data: SignupEventData = {
    event: 'self_sign_up_completed',
    trigger: 'GAevent',
    event_id: 5,
    eventCategory: 'self_sign_up_flow',
  };

  try {
    data.hashedEmail = await encodeToSHA256HashString(email);
  } catch (e) {
    // no need to do anything if hashing fails
    // we don't send the email for unsupported browsers
  }

  return data;
};

/**
 * This  is the existing event format
 * in order to migrate we need to keep
 * it because we will change per geolocations.
 */
export const getGTMLegacySignupEvent = () => {
  return {
    event: 'GAevent',
    event_id: '23',
    eventCategory: 'self_sign_up_flow',
    eventAction: 'self_sign_up_completed',
  };
};
